<template>
  <div id="page-wrap" v-if="loggedIn">
    <div class="container content-wrap">
      <div class="row">
        <section>
          <div class>
            <StateItem v-for="item in states" :key="item" :item="item" />
          </div>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import StateItem from "./StateItem/index";
export default {
  name: "state",
  data() {
    return {};
  },
  components: { StateItem },
  computed: {
    ...mapGetters(["loggedIn", "states"])
  },
  mounted() {
    this.$store.dispatch("storeMixpanelEvent", {
      eventName: "BILL_PAYMENT_SELECTED",
      propertyName: "BILL_TYPE",
      propertyValue: this.$route.params.category.toUpperCase()
    });
    this.$store.dispatch("getBillers", this.$route.params.category);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/State.vue